module.exports = __webpack_public_path__ + "img/dt_logo.86241ee2.png";